import React from 'react';
import styled from 'styled-components';

export default function Compliancesection() {
 return (
  <Container>
   <Wrapper>
    <Compliancecontainer>
     <div className='header'>
      <Heading>How to Start my Compliance?</Heading>
      <Linebreak>
       <div className='part1'></div>
       <div className='part2'></div>
       <div className='part3'></div>
      </Linebreak>
     </div>
     <Content>
      <p>
       Every producer or brand-owner shall, for the purpose of registration or
       renewal of registration, make an application, in Form 1 to, -
      </p>{' '}
      <ul>
       <li>
        <p>
         The concerned State Pollution Control Board or Pollution Control
         Committee of the Union territory, if operating in one or two states or
         Union territories; or
        </p>
       </li>
       <li>
        <p>
         The Central Pollution Control Board, if operating in more than two
         States or Union Territories.
        </p>
       </li>
      </ul>
     </Content>
    </Compliancecontainer>
   </Wrapper>
  </Container>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 background: #ededed;
`;

const Wrapper = styled.div`
 display: flex;
 align-items: center;
 width: 75%;
 margin: 0 auto;
 .header {
  width: fit-content;
  margin-bottom: 3rem;
 }
 @media screen and (max-width: 600px) {
  width: 90%;
 }
`;

const Compliancecontainer = styled.div`
 padding: 8rem;
 width: 100%;
`;

const Heading = styled.h1`
 font-size: 3.2rem;
 font-weight: 600;
 line-height: 7rem;
 /* font-family: 'Segoe UI'; */
 color: #444444;
`;

const Linebreak = styled.div`
 width: 50%;
 display: flex;
 gap: 0.5rem;
 margin-top: -1rem;
 div {
  background-color: #84d908;
  border-radius: 1rem;
  height: 0.5vh;
 }
 .part1 {
  width: 40%;
 }
 .part2 {
  width: 30%;
 }
 .part3 {
  width: 10%;
 }
`;

const Content = styled.div`
 margin-top: 2rem;
 /* font-family: 'Segoe UI'; */
 color: #707070;
 text-align: justify;

 p {
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2rem;
  margin-bottom: 2rem;
 }
`;
